/**
 * ADR-106 §5 — the two populations an audit row can belong to. Literal mirror
 * of `radar-api/src/utils/feedbackModificationAuditScopes.js`.
 *
 * A modification audit row is anchored to a feedback session (session-scoped
 * assignment) OR to an individual assignment (no session).
 */
export const AUDIT_SCOPES = {
  SESSION: 'session',
  INDIVIDUAL: 'individual',
};

export const AUDIT_SCOPE_OPTIONS = [
  { value: '', label: 'All scopes', description: 'Modifications on feedback sessions and on individual assignments' },
  { value: AUDIT_SCOPES.SESSION, label: 'Feedback sessions', description: 'Modifications on assignments that belong to a feedback session' },
  { value: AUDIT_SCOPES.INDIVIDUAL, label: 'Individual assignments', description: 'Modifications on individual assignments, which have no session — session filters do not apply to them' },
];

export const getAuditScopeLabel = (scope) =>
  (AUDIT_SCOPE_OPTIONS.find(o => o.value === scope) || AUDIT_SCOPE_OPTIONS[0]).label;
